import FHIR from 'fhirclient';

const FHIR_CONFIG = {
  clientId: import.meta.env.VITE_FHIR_CLIENT_ID,
  redirectUri: import.meta.env.VITE_FHIR_REDIRECT_URI, // <-- app's URL (e.g., http://localhost:5173/ or https://copilot.avvacare.com/)
  fhirBaseUrl: import.meta.env.VITE_FHIR_BASE_URL,    // <-- FHIR server base URL
  scope: import.meta.env.VITE_FHIR_SCOPE,
};


export const initializeFhirClient = async () => {
  try {
    // Log current window URL params  
    const currentUrlParams = new URLSearchParams(window.location.search);
    console.debug("Current window URL params:", window.location.search);
    for (const [key, value] of currentUrlParams) {
      console.debug(`  Param: ${key} = ${value}`);
    }

    let authorizeOptions = {
      clientId: FHIR_CONFIG.clientId,
      redirectUri: FHIR_CONFIG.redirectUri,
      scope: FHIR_CONFIG.scope
    };

    // eslint-disable-next-line
    let issParam = currentUrlParams.get('iss');
    let launchParam = currentUrlParams.get('launch');

    if (launchParam) {
      authorizeOptions.launch = launchParam;
      authorizeOptions.scope = "launch " + authorizeOptions.scope;
      authorizeOptions.completeInTarget = true;
    } else {
      authorizeOptions.iss = FHIR_CONFIG.fhirBaseUrl; // <-- FHIR server base URL
    }

    if (!currentUrlParams.get('state') || !currentUrlParams.get('code')) {
      console.log('Initiating FHIR authorization ...');
      FHIR.oauth2.authorize(authorizeOptions);
      return null; // Wait for redirect
    }
    const client = await FHIR.oauth2.ready();
    return client;
  } catch (error) {
    console.error('FHIR auth error:', error);
    throw new Error('Failed to initialize FHIR client');
  }
};

export const fetchCareTeam = async (client) => {
  try {
    // get the patient ID from the client
    let patientId = client.patient.id;

    // use the client to load the Patient resource
    let patientResponse = await client.request(`Patient/${patientId}`);

    // instantiate Patient object with the response
    // TODO: create Patient model object

    // get patient's preferred language
    // let preferredLanguage = null;
    // if (patientResponse.communication && patientResponse.communication.length > 0) {
    //   preferredLanguage = patientResponse.communication.filter((obj) => obj.preferred);
    //   if (preferredLanguage.length > 0) {
    //     preferredLanguage = preferredLanguage[0].language.coding[0].code;
    //   }
    // }
    let preferredLanguage = "en"; // not yet supporting different languages

    if (!patientResponse.generalPractitioner || patientResponse.generalPractitioner.length === 0) {
      // handle no practitioner case
    }

    let practitionerReference = patientResponse.generalPractitioner[0].reference;
    // get the patient's Practitioner
    let practitionerResponse = await client.request(practitionerReference);

    // isntantiate Practitioner object with the response
    // TODO: create Practitioner model object

    // get the patient's CareTeam
    //let careteamResponse = await client.request('/CareTeam?patient=' + patientId); // TODO: still getting 403 on this

    //let practitionerRoleResponse =  await client.request(`PractitionerRole?practitioner=${practitionerResponse.id}`); // TODO: still getting 403 on this

    return {
      careTeam: [{ name: practitionerResponse.name[0].text, role: "Role Unavailable", imageUrl: practitionerResponse.photo[0].url }],
      preferredLanguage
    };

  } catch (error) {
    console.error('Care Team fetch error:', error);
    throw new Error('Failed to fetch Care Team');
  }
};